import { api } from '@/helpers/base/api'

export const subDomains = {
  namespaced: true,
  actions: {
    async load(ctx) {
      try {
        ctx.commit('updateLoading', true)
        ctx.commit('updateError', { status: false })

        const domains = ctx.rootGetters.domains.slice(0, 10)
        const viewId = ctx.rootState.view.viewId

        const results = await Promise.all(
          domains.map(domain =>
            api.get('/data/getSubDomains', {
              domainName: domain,
              id: viewId,
            }, { timeout: 30000 })
          )
        )

        const data = results
          .filter(r => r.success && r.data?.length)
          .map(r => ({
            domainName: r.data[0].domainName,
            data: r.data[0].data,
            totalCount: r.data[0].totalCount,
          }))

        ctx.commit('updateData', data)
        ctx.commit('updateLoading', false)
      } catch (error) {
        console.error(error)
        ctx.commit('updateLoading', false)
        ctx.commit('updateError', { status: true, name: 'cannotLoad' })
      }
    },
  },
  state: () => ({
    data: [],
    loading: false,
    error: { status: false },
    loaded: false,
  }),
  mutations: {
    updateData(state, data) {
      state.data = data
      state.loaded = true
    },
    updateLoading(state, status) {
      state.loading = status
    },
    updateError(state, errorData) {
      state.error = errorData
    },
    resetLoaded(state) {
      state.loaded = false
    },
  },
  getters: {
    allSubDomains(state) {
      return state.data
    },
  },
}
